"use client";

import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted-light/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/40 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground-light hover:text-primary transition-colors duration-200 underline-offset-4 hover:underline">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer className="w-full bg-light-background border-t border-border py-8 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-sm text-foreground-light">© 2026 Flex R&amp;D All rights reserved.</div>

        <MenuProvider menu_id="17">
          <FooterMenuConsumer />
        </MenuProvider>
      </div>
    </footer>;
}